<template>
  <page-content v-if="hasPermission('package_view')">

    <panel title="Thông tin tìm kiếm">

      <c-form ref="searchForm">

        <b-row>
          <c-input v-model="packageOrders"
                   form-group-class="col"
                   label="Package order"
                   placeholder='Danh sách đơn hàng (Ngăn cách bằng dấu ",")'
                   validate-rules="required"/>

        </b-row>

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success" type="button" @click="searchFf()">
              <i class="fas fa-search"></i> Tìm kiếm trên hệ thống FF
            </button>

            <button class="btn btn-success" type="button" @click="searchEcom()">
              <i class="fas fa-search"></i> Tìm kiếm trên hệ thống Ecom
            </button>

          </b-col>
        </b-row>
      </c-form>

    </panel>

    <b-row class="packageInfo">
      <b-col v-show="showFF" :md="showEcom ? 6: 12">
        <panel :is-open.sync="showFF"
               show-close
               show-collapse
               title="Thông tin đơn hàng trên hệ thống FF"
               @close="fFData = []"
        >
          <b-table
              :fields="[
                  'bill_package_id',
                  'package_order',
                  'request_at',
                  'bill_package_status',
                  'bill_type',
                  'src_warehouse_ff',
                  {key:'show_details', label: 'Chi tiết', tdClass:'text-center'},
              ]"
              :items="fFData"
              :responsive="true"
              bordered
              hover
              small
          >
            <template #cell(request_at)="row">
              {{row.item.request_at | datetime}}
            </template>

            <template #cell(show_details)="row">
              <b-button
                  class="btn btn-icon"
                  title="Xem chi tiết"
                  variant="success"
                  @click="row.toggleDetails"
              >
                <i :class="{'fa-eye': !row.detailsShowing, 'fa-eye-slash': row.detailsShowing}" class="fas"></i>
              </b-button>

              <b-button
                  class="btn btn-icon"
                  title="Hủy đơn"
                  variant="danger"
                  @click="showConfirmCancelPackage = true; selectedPackageOrder = row.item.package_order"
                  v-if="hasPermission('package_delete') && row.item.bill_package_status !== 101"
              >
                <i class="fas fa-ban"></i>
              </b-button>
            </template>

            <template #row-details="row">
              <b-card>

                <b-table-simple bordered hover>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail">bill id</b-th>
                    <b-td>{{ row.item.bill_id }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail">bill alias</b-th>
                    <b-td>{{ row.item.bill_alias }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >bill status</b-th>
                    <b-td>{{ row.item.bill_status }}</b-td>
                  </b-tr>

                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >shop order</b-th>
                    <b-td>{{ row.item.shop_order }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >station id</b-th>
                    <b-td>{{ row.item.station_id }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >src warehouse id</b-th>
                    <b-td>{{ row.item.src_warehouse_id }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >src warehouse name</b-th>
                    <b-td>{{ row.item.src_warehouse_name }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >src warehouse ff</b-th>
                    <b-td>{{ row.item.src_warehouse_ff }}</b-td>
                  </b-tr>

                  <b-tr v-if="row.item.src_warehouse_id != row.item.dst_warehouse_id">
                    <b-th class="text-sm-right td-label-detail" >dst warehouse id</b-th>
                    <b-td>{{ row.item.dst_warehouse_id }}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >created at</b-th>
                    <b-td>{{row.item.created_at | datetime}}</b-td>
                  </b-tr>

                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >updated at</b-th>
                    <b-td>{{row.item.updated_at | datetime}}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >approved at</b-th>
                    <b-td>{{row.item.approved_at | datetime}}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >approved by</b-th>
                    <b-td>{{row.item.approved_by}}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >description</b-th>
                    <b-td>{{row.item.description}}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >start shift time</b-th>
                    <b-td>{{row.item.start_shift_time | datetime}}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >end shift time</b-th>
                    <b-td>{{row.item.end_shift_time | datetime}}</b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="text-sm-right td-label-detail" >printed</b-th>
                    <b-td>{{row.item.printed}}</b-td>
                  </b-tr>


                  <b-tr>
                    <b-th class="text-sm-right td-label-detail">Ds sản phẩm</b-th>
                    <b-td>
                      <b-table
                          :fields="[
                              'product_id',
                              'full_name',
                              'status',
                              'quantity',
                              'image_paths',
                          ]"
                          :items="row.item.product_infos"
                          :responsive="true"
                          bordered
                          hover
                          small
                      >
                        <template #cell(image_paths)="productInfo">
                          <img :src="i" v-for="i in productInfo.item.image_paths" style="width: 30px; height: 30px">
                        </template>
                      </b-table>
                    </b-td>
                  </b-tr>

                </b-table-simple>

                <hr/>
                <b-button size="sm" @click="row.toggleDetails"><i class="fas fa-eye-slash"></i> Ẩn chi tiết</b-button>
              </b-card>
            </template>
          </b-table>
        </panel>
      </b-col>
      <b-col v-show="showEcom" :md="showFF ? 6: 12">
        <panel :is-open.sync="showEcom"
               show-close
               show-collapse
               title="Thông tin đơn hàng trên hệ thống ecom">

          <b-table :fields="[
                   { key: 'actions', label: 'Thao tác'},
                   'order',
                   'is_cancel',
                   'package_status_id',
                   'shop_id',
                   'created',
                   'pick_address_id',
                   'pick_first_address',
                   ]"
                   :items="ecomData"
                   :responsive="true"
                   bordered
                   hover
                   small
                   style="table-layout:fixed;"
          >
            <!-- A virtual column -->

            <template #head(actions)>
              <b-row style="margin : auto">
                <input type="checkbox" style="width : 30px; height: 30px; margin-right: 10px;" @change="selectAll('DANG_DON')" v-model="isSelectAll">

                <b-button
                    v-if="hasPermission('package_create')"
                    class="btn btn-icon"
                    title="Đăng đơn"
                    type="button"
                    variant="success"
                    @click="packagesProducer(packageRequestSelected)"
                >
                  <i class="far fa-shipping-fast"></i>
                </b-button>

              </b-row>
              <b-row style="margin : auto">
                <input type="checkbox" style="width : 30px; height: 30px; margin-right: 10px;" @change="selectAll('DANG_LAI_DON')" v-model="isSelectAllPackageRetry">

                <b-button
                    v-if="hasPermission('package_delete') && hasPermission('package_create')"
                    class="btn btn-icon"
                    title="Xử lý đăng lại đơn hàng"
                    variant="danger"
                    @click="reProducePackages(listSelectedPackageOrder)"
                >
                  <i class="fas fa-reply-all"></i>
                </b-button>
              </b-row>
            </template>

            <template #cell(actions)="data">
              <b-row style="margin : auto">
                <input v-if="!data.item.existed" v-model="packageRequestSelected" :value="format(data.item)" type="checkbox" style="width : 30px; height: 30px; margin-right: 10px;">

                <b-button
                    v-if="hasPermission('package_create') && !data.item.existed"
                    class="btn btn-icon"
                    title="Đăng đơn"
                    type="button"
                    variant="success"
                    @click="packageProducer(data.item)"
                >
                  <i class="far fa-shipping-fast"></i>
                </b-button>

                <input v-if="data.item.existed" v-model="listSelectedPackageOrder" :value="data.item.order" type="checkbox" style="width : 30px; height: 30px; margin-right: 10px;">

                <b-button
                    v-if="hasPermission('package_delete') && hasPermission('package_create') && data.item.existed"
                    class="btn btn-icon"
                    title="Xử lý đăng lại đơn hàng"
                    variant="danger"
                    @click="showConfirmReProduce = true; selectedPackageOrder = data.item.order"
                >
                  <i class="fas fa-reply-all"></i>
                </b-button>
              </b-row>
            </template>

            <template #cell()="data">
              <span :title="data.value">{{ data.value }}</span>
            </template>

            <template #cell(created)="data">
              <span :title="data.value | datetime">{{ data.value | datetime }}</span>
            </template>

            <template #row-details="row">
              <b-card>
                <b-row class="mb-2">
                  <b-col class="text-sm-right" sm="3"><b>Age:</b></b-col>
                  <b-col>{{ row.item.age }}</b-col>
                </b-row>

                <b-row class="mb-2">
                  <b-col class="text-sm-right" sm="3"><b>Is Active:</b></b-col>
                  <b-col>{{ row.item.isActive }}</b-col>
                </b-row>

                <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
              </b-card>
            </template>
          </b-table>
        </panel>

      </b-col>
    </b-row>


    <jc-dialog ref="dialog" :show.sync="showConfirmReProduce"
               btn-confirm-text='<i class="fas fa-check-circle"></i> Xác nhận'
               title="Xác nhận đăng lại đơn"
               type="red"
               @onConfirm="reProducePackage()"
    >

      <p>
        Lựa chọn này sẽ xóa hoàn toàn thông tin đơn hàng đã có trên hệ thống để thực hiện đăng đơn lại và không thể khôi phục lại.
      </p>
      <h5>
        Xác nhận thực hiện đăng lại đơn hàng <code>{{ selectedPackageOrder }}</code> ?
      </h5>


    </jc-dialog>

    <jc-dialog ref="dialog" :show.sync="showConfirmCancelPackage"
               btn-confirm-text='<i class="fas fa-check-circle"></i> Xác nhận'
               title="Xác nhận hủy đơn"
               type="red"
               @onConfirm="cancelPackage()"
    >

      <p>
        Việc hủy đơn sẽ tính lại số lượng tồn kho của sản phẩm.
      </p>
      <h5>
        Xác nhận hủy đơn hàng <code>{{ selectedPackageOrder }}</code> ?
      </h5>


    </jc-dialog>

  </page-content>
</template>

<script>
export default {
  name: "Index",
  data() {
    return {
      packageOrders: '',
      ecomData: [],
      fFData: [],
      showEcom: false,
      showFF: false,
      showConfirmReProduce: false,
      showConfirmCancelPackage: false,
      selectedPackageOrder: null,
      packageRequestSelected : [],
      listSelectedPackageOrder : [],
      isSelectAll : false,
      isSelectAllPackageRetry : false,
      typeSelectAll : '' // đăng lại đơn hoặc đăng đơn
    }
  },
  methods: {
    selectAll(typeSelectAll) {
      if(this.isSelectAll && typeSelectAll==='DANG_DON') {
        this.packageRequestSelected = this.ecomData.filter(item=>!item.hasOwnProperty('existed')).map(item=>({
          "package_status_id": item.package_status_id,
          "pick_address": item.pick_first_address,
          "pick_address_id": item.pick_address_id,
          "pkg_order": item.order,
          "request_date": item.created,
          "shop_id": item.shop_id
        }));
      } else if(this.isSelectAllPackageRetry && typeSelectAll==='DANG_LAI_DON') {
        this.listSelectedPackageOrder = this.ecomData.filter(item=>item.hasOwnProperty('existed')).map(item => item.order);
      } else {
        if(!this.isSelectAllPackageRetry) {
          this.listSelectedPackageOrder = [];
        }
        if(!this.isSelectAll) {
          this.packageRequestSelected = [];
        }
      }
    },
    format(item) {
      return {
        "package_status_id": item.package_status_id,
        "pick_address": item.pick_first_address,
        "pick_address_id": item.pick_address_id,
        "pkg_order": item.order,
        "request_date": item.created,
        "shop_id": item.shop_id
      }
    },
    searchEcom() {
      setTimeout(()=>{
        this.$refs.searchForm
        .validate()
        .then(() => {
          this.$http.post("/moshop/api/fulfilment/v1/ff/package/list", {
            "package_orders": this.packageOrders.split(',').map(x => x.trim())
          }).then(res => {
            if (res.data.success) {
              this.ecomData = res.data.data;
              this.showEcom = true;
              if (this.showFF) {
                this.highlightMissedPackage();
              }
              this.listSelectedPackageOrder = [];
            } else {
              this.$error(res.data.message)
            }
            this.packageRequestSelected = [];
          }).catch(error => {
            this.errorNotify(error);
          })
        })
      },500);
    },
    searchFf() {
      setTimeout(()=>{
        this.$refs.searchForm
        .validate()
        .then(() => {
          this.$http.post(
              "/cms/api/v1.0/bill-package/get-bill-package-info",
              {
                "package_orders": this.packageOrders.split(',').map(x => x.trim())
              })
          .then(res => {
            this.fFData = res.data;
            this.disabledRow();
            this.showFF = true;
            if (this.showEcom) {
              this.highlightMissedPackage();
            }
            this.packageRequestSelected = [];
          }).catch(error => {
            this.errorNotify(error);
          })
        })
      },500);
    },
    packageProducer(ecomPackageInfo) {
      this.$http.post(
          '/package-service/v1.0/kafka/producer',
          {
            "package_status_id": ecomPackageInfo.package_status_id,
            "pick_address": ecomPackageInfo.pick_first_address,
            "pick_address_id": ecomPackageInfo.pick_address_id,
            "pkg_order": ecomPackageInfo.order,
            "request_date": ecomPackageInfo.created,
            "shop_id": ecomPackageInfo.shop_id
          }
      ).then(res => {
        this.$success();
        this.searchFf();
      }).catch(err => {
        this.errorNotify(err);
      })
    },
    packagesProducer(listData) {

      let promises = [];
      let completed = false;

      for(let i = 0; i < listData.length; i++) {
        promises.push(
            this.$http.post(
                '/package-service/v1.0/kafka/producer',
                {
                  "package_status_id": listData[i].package_status_id,
                  "pick_address": listData[i].pick_address,
                  "pick_address_id": listData[i].pick_address_id,
                  "pkg_order": listData[i].pkg_order,
                  "request_date": listData[i].request_date,
                  "shop_id": listData[i].shop_id
                }
            ).then(res => {
              completed = true;
            }).catch(err => {
              this.errorNotify(err);
              completed = false;
              return;
            })
        );
      }

      Promise.all(promises).then(() =>
          {
            if(completed) {
              setTimeout(()=>{
                this.$success();
                this.searchFf();
                this.isSelectAll = false;
              },1000);
            }
          }
      );

    },
    highlightMissedPackage() {
      this.ecomData.forEach((value, index, array) => {
        if (!this.fFData.filter(x => x.package_order === value.order).length) {
          value._rowVariant = 'danger';
        } else {
          value._rowVariant = 'success';
          value.existed = true;
        }
      })
    },
    reProducePackage() {
      this.$cmsService.put(`/api/v1.0/bill-package/re-produce-package/${this.selectedPackageOrder}`)
          .then(
              res => {
                this.$success()
                this.showConfirmReProduce = false;
                this.searchEcom();
                this.searchFf();
              },
              err => {
                this.errorNotify(err)
                    .then(errorRes => this.$cmsBadRequest(errorRes))
              }
          );
    },

    reProducePackages(listData) {
      let promises = [];
      let completed = false;

      promises.push(
          this.$cmsService.put(`/api/v1.0/bill-package/re-produce-package`,listData)
          .then(
              res => {
                completed = true;
              },
              err => {
                this.errorNotify(err)
                .then(errorRes => this.$cmsBadRequest(errorRes))
              }
          )
      );

      Promise.all(promises).then(() =>
          {
            if(completed) {
              setTimeout(()=>{
                this.$success();
                this.searchEcom();
                this.searchFf();
                this.isSelectAllPackageRetry = false;
              },1000);
            }
          }
      );
    },

    cancelPackage(){
      if(!!this.selectedPackageOrder){
        this.$billService.post(`/v1.0/kafka/package/cancel`,
            {
              "date": new Date().getTime(),
              "pkg_order": this.selectedPackageOrder,
              "is_cancel": 1
            })
        .then(res => {
          this.$success();
          this.showConfirmCancelPackage = false;
          this.searchFf();
        })
        .catch(err => {
          this.errorNotify(err)
              .then(errorRes => this.$cmsBadRequest(errorRes));
        })
      }
    },
    disabledRow(){
      this.fFData.forEach((value, index, array) => {
        if(value.bill_package_status == 101){
          value._rowVariant = 'secondary';
        }
      })
    }
  }
}
</script>

<style>
.packageInfo table {
  table-layout: fixed;

}

.packageInfo table .table-secondary{
  cursor: not-allowed;
}
.packageInfo .td-label-detail{
  width: 150px;
}

</style>
